import { server } from '../constants';
import { httpClient } from '../utils/HttpClient';

/*______________
 *  Label Data 
 *==============
 */

/**
 * getListAll()
 * @returns
 * Detail: get list all of label data
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Master/Label
 */
export function getListAll() {
  return httpClient
    .get(`${server.LABEL_URL}/getListAll`)
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}